<template>
  <input v-maska="opcoes" :value="modelValue" />
</template>

<script>
import { vMaska } from 'maska/vue';

/**
 * Drop-in replacement for `<the-mask>` from `vue-the-mask`, which stopped at Vue 2 and
 * has no successor from the same author.
 *
 * It exists so the five call sites (novo-cadastro, marketplace, three in resumo_tfl)
 * keep their template API — `:mask`, `:masked`, `v-model` — while the engine
 * underneath is `maska`. Both use `#` for a digit, and both accept an array of masks
 * and pick one by input length, which is what novo-cadastro relies on for CPF/CNPJ.
 *
 * The value is emitted from maska's `onMaska` callback, NOT from the element's
 * `input` event. Template listeners are attached before the directive's `mounted`
 * hook, so an `@input` handler here would run BEFORE maska rewrites the value and
 * hand the model the raw keystrokes instead of the formatted text.
 *
 * `masked` keeps vue-the-mask's meaning: true emits the formatted text, false the
 * digits only. All five call sites pass `:masked="true"` today.
 */
export default {
  name: 'TheMask',
  directives: { maska: vMaska },
  props: {
    modelValue: { type: [String, Number], default: '' },
    mask: { type: [String, Array], required: true },
    masked: { type: Boolean, default: false },
  },
  emits: ['update:modelValue'],
  computed: {
    opcoes() {
      return {
        mask: this.mask,
        onMaska: detalhe => {
          this.$emit('update:modelValue', this.masked ? detalhe.masked : detalhe.unmasked);
        },
      };
    },
  },
};
</script>
